<template>
    <div class="container">
        <div class="main">
            <div class="content">
                <div class="infoBox">
                    <div class="userinfo">
                        <div class="userinfo-l">
                            <img :src="item.icon?item.icon:require('@/assets/default-avatar.png')" />
                        </div>
                        <div class="userinfo-r">
                            <div class="username-wrap">
                                <div class="username">{{item.circleName}}</div>
                            </div>
                            <div class="user-type">圈成员 {{item.followNum}}</div>
                        </div>
                    </div>
                    <div class="userinfo-tips">{{item.content}}</div>
                    <div class='rankBtn' @click.stop="toRank()"><i class="el-icon-s-data"></i> 用户榜</div>
                    <div class='joinBtn' v-if="item.isJoin==1" @click.stop="toUnEnter()">已加入</div>
                    <div class="joinBtn" v-else @click.stop="toEnter()">加入</div>
                </div>
                <div class='cardBox'>
                    <div class='cardTitle'>圈主</div>
                    <div class='userBox'>
                        <div class="userinfo" v-for="(_item,index) in item.leaderList" :key="index">
                            <div class="userinfo-l" @click.stop="toUserIndex(_item.id)">
                                <img :src="_item.headPic?_item.headPic:require('@/assets/default-avatar.png')" />
                            </div>
                            <div class="userinfo-r">
                                <div class="username-wrap" @click.stop="toUserIndex(_item.id)">
                                    <div class="username">{{_item.nickName}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class='cardBox'>
                    <div class="ub ub-pj">
                        <div class='cardTitle'>活跃用户</div>
                        <div @click="toMore" class="titleMore">查看更多<span class="el-icon-caret-right"></span></div>
                    </div>
                    <div class="ub ub-pj item-user mt-2" v-for="(item, index) in listUser" :key="index">
                        <div class="user-l ub ub-ac">
                            <div class="tltleIndex">{{item.orderNum}}</div>
                            <img class="ml-1" :src="item.headPic?item.headPic:require('@/assets/default-avatar.png')"/>
                            <div class="tltleName ml-1">{{item.nickName}}</div>
                            <div class="level" v-if="item.circleLevel">
                                <img :src="item.circleLevel">
                            </div>
                        </div>
                        <div class="user-r">
                            <div class="tltleIndexNum">{{item.activeNum}}</div>
                            <div>贡献值</div>
                        </div>
                    </div>
                    <Pagination v-if="showPage == 1" :pageSize="pageSize" :pageNum="pageNum" :total="total" @pageChange="pageChange"/>
                </div>
                <div class='cardBox'>
                    <div class='cardTitle'>圈子规范</div>
                    <div class="rulesBox" v-html='item.circleRule'></div>
                </div>
            </div>
            <!-- <div class="aside">
                <asideNews />
                <asideCircle />
            </div> -->
        </div>
    </div>
</template>
<script>
import asideNews from '@/components/aside/news'
import asideCircle from '@/components/aside/recommendCircle'
import Pagination from '@/components/pagination'
import qs from 'qs'
import { post, ajaxParam } from '@/units/request.js'
export default {
    name: 'introduce',
    components: {
        asideNews,
        asideCircle,
        Pagination
    },
    data() {
        return {
            item: {},
            listUser: [],
            pageSize: 10,
            pageNum: 1,
            total: 10,
            showPage: 0
        }
    },
    created() {
        this.userId = localStorage.getItem('userId') || ''
        this.id = this.$route.query.id
        this.getDetailById()
    },
    watch: {
        $route(to, from) {
            this.id = to.query.id
            this.getDetailById()
        }
    },
    methods: {
        toMore(){
            this.showPage = 1
            this.getDataListUser()
        },
        async getDataListUser(){
            let param = {
                circleId: this.id,
                pageNum: this.pageNum,
                pageSize: this.pageSize
            }
            ajaxParam(param)
            const res = await post('v1/circle/activeUserList', qs.stringify(param))
            if(res.data.code==200){
                this.listUser = res.data.list
                this.total = res.data.total
            } else {
                this.$message.error(res.data.msg)
            }
        },
        pageChange(e) {
            this.listUser = []
            this.pageNum = e.number
            this.getDataListUser()
        },
        //根据id获取详情
        async getDetailById() {
            let param = {
                circleId: this.id,
                userId: this.userId
            }
            ajaxParam(param)
            const res = await post('v1/circle/circleInfo', qs.stringify(param))
            if (res.data.code == 200) {
                this.item = res.data.entity
                this.listUser = this.item.activeUserList
            } else {
                this.$message.error(res.data.msg)
            }
        },
        async toEnter(item) {
            if (!this.userId) {
                this.$router.push({
                    path: '/login'
                })
                return
            }
            let param = {
                userId: this.userId,
                circleId: this.item.id,
                circleIds: ''
            }
            ajaxParam(param)
            const res = await post('v1/circle/joinCircle', qs.stringify(param))
            if (res.data.code == 200) {
                console.log(res.data)
                this.$message.success('加入成功！')
                this.item.isJoin = 1
            } else {
                this.$message.error(res.data.msg)
            }
        },
        async toUnEnter(item) {
            if (!this.userId) {
                this.$router.push({
                    path: '/login'
                })
                return
            }
            let param = {
                userId: this.userId,
                circleId: this.item.id
            }
            ajaxParam(param)
            const res = await post('v1/circle/quitCircle', qs.stringify(param))
            if (res.data.code == 200) {
                this.$message.success('退出成功！')
                this.item.isJoin = 0
            } else {
                this.$message.error(res.data.msg)
            }
        },
        toRank() {
            this.$router.push({
                path: '/circleRank?id=' + this.item.id
            })
        },
        toUserIndex(id) {
            this.$router.push({
                path: '/userIndex?id=' + id
            })
        }
    }
}
</script>
<style lang="less" scoped>
.container {
    .main {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        width: 1180px;
        margin: 20px auto;

        .content {
            flex: 1;

            .userinfo {
                display: flex;
                cursor: pointer;

                .userinfo-l img {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                }

                .userinfo-r {
                    margin-left: 6px;

                    .username-wrap {
                        display: flex;
                        align-items: center;

                        .username {
                            font-size: 16px;
                            font-weight: bold;
                        }
                    }

                    .user-type {
                        opacity: .7;
                        font-size: 12px;
                        margin-top: 5px;
                    }
                }
            }

            .infoBox {
                background: #fff;
                padding: 20px 30px;
                border-radius: 10px;

                .userinfo-tips {
                    margin-top: 15px;
                    opacity: .7;
                    font-size: 12px;
                }

                .rankBtn {
                    border-radius: 4px;
                    border: 1px solid rgba(50, 50, 51, .14);
                    color: #333;
                    line-height: 32px;
                    text-align: center;
                    margin-top: 15px;
                    cursor: pointer;
                }

                .joinBtn {
                    border-radius: 17px;
                    background: #333;
                    color: #fff;
                    line-height: 34px;
                    text-align: center;
                    margin-top: 10px;
                    cursor: pointer;
                }
            }

            .cardBox {
                margin-top: 20px;
                background: #fff;
                padding: 20px 30px;
                border-radius: 10px;

                .cardTitle {
                    font-weight: bold;
                    font-size: 18px;
                    padding-bottom: 15px;
                }
                .titleMore{
                    font-size: 12px;
                    color: #666;
                    cursor: pointer;
                }
            }

            .userBox {
                display: flex;
                flex-wrap: wrap;

                .userinfo {
                    margin-top: 5px;
                    margin-right: 15px;
                    align-items: center;
                }
            }

            .rulesBox {
                opacity: 0.7;
            }

        }

        .aside {
            width: 300px;
            margin-left: 20px;
        }
    }
    .item-user{
        .tltleIndex{
            font-size: 16px;
            font-weight: 500;
            color: #333;
            width:24px;
        }
        img{
            width: 40px;
            height: 40px;
            border-radius: 50%;
        }
        .user-r{
            text-align: center;
            font-size: 12px;
            color: #666;
            .tltleIndexNum{
                font-size: 18px;
                font-weight: 500;
                color:#333;
            }
        }
    }
    .level{
		margin-left:5px;
		img{
			height:16px;
            width: auto;
            margin-top: 0;
		}
	}
}
	
</style>